"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    heading: {
      margin: spacing(2)
    },
    wrapper: {
      minWidth: 'auto'
    }
  };
});

var RepresentativeAssignUnits = function RepresentativeAssignUnits(_ref2) {
  var units = _ref2.units,
      assignedUnits = _ref2.assignedUnits,
      editableUnits = _ref2.editableUnits,
      info = _ref2.info,
      handleUnitChange = _ref2.handleUnitChange,
      handleUnitClick = _ref2.handleUnitClick;
  var classes = useStyles();
  var Wrapper = handleUnitChange ? _core.ListItemSecondaryAction : _core.ListItemIcon;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, info && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.heading,
    variant: "body1"
  }, info), /*#__PURE__*/_react["default"].createElement(_core.List, {
    dense: true,
    className: classes.root
  }, units.map(function (_ref3) {
    var _id = _ref3._id,
        key = _ref3.key,
        name = _ref3.name,
        location = _ref3.location;
    var labelId = "checkbox-list-secondary-label-".concat(_id);
    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, _extends({
      key: _id
    }, handleUnitClick && editableUnits[_id] ? {
      button: true,
      onClick: function onClick() {
        return handleUnitClick(_id);
      }
    } : {}), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      id: labelId,
      primary: "".concat(key, ". ").concat(name),
      secondary: location.formatted_address
    }), /*#__PURE__*/_react["default"].createElement(Wrapper, {
      className: classes.wrapper
    }, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, _extends({
      color: "primary",
      edge: "end",
      disabled: !editableUnits[_id],
      checked: !!assignedUnits[_id],
      name: _id
    }, handleUnitChange ? {
      onChange: handleUnitChange
    } : {
      disableRipple: true,
      inputProps: {
        'aria-labelledby': labelId
      }
    }))));
  })));
};

var _default = RepresentativeAssignUnits;
exports["default"] = _default;